import {Component, EventEmitter, Input, Optional, Output} from "@angular/core";
import {StatusPanelService} from "./status-panel.service";

export enum Status {
    LOADING,
    REQUIRED,
    PENDING,
    COMPLETE,
    FAILED_TO_LOAD,
    NOT_READY,
    NONE
}

export interface StatusPanelController {
    /**
     * Close the panel
     */
    close(): void;
}

@Component({
    selector: "fhm-status-panel",
    templateUrl: "./status-panel.component.html",
    styleUrls: ["./status-panel.component.scss"],
    standalone: false
})
export class StatusPanelComponent {
    Status = Status;

    @Input() title: string;

    @Input() status: Status = Status.NONE;

    constructor(@Optional() private statusPanelService: StatusPanelService) {

    }
}
